import { createContext } from 'react';

export const FetchingContext = createContext<{
  isFetching: boolean;
}>({
  isFetching: true,
});
